import { GenericService } from './generic.service';
import { Permission } from '@/models';

export class OrganisationPermissionService extends GenericService<Permission> {

  constructor(organisationId: string) {
    super(`v1/organisations/${organisationId}/permissions`);
  }
}
